import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-support',
  imports: [FormsModule],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss'
})
export class SupportComponent {
  submitForm(contactForm: any) {
    // Handle form submission logic
    console.log('Form Submitted', contactForm.value);
  }
}
